// src/components/ImageGallery/ImageGallery.js

import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../LoadingSpinner.js';
import ImageCategoryCard from './ImageCategoryCard.js'; 

const API_BASE_URL = "https://test-api.stainedglassusa.com";

export default function ImageGallery() {
    const [featuredImages, setFeaturedImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        
        fetch(`${API_BASE_URL}/images`) 
            .then(res => {
                if (!res.ok) { throw new Error(`HTTP error: ${res.status} ${res.statusText}`); }
                return res.json();
            })
            .then(data => {
                 if (!Array.isArray(data)) { throw new Error("Invalid data format received"); }
                setFeaturedImages(data);
                console.log("Fetched featured images:", data);
            })
            .catch(error => {
                console.error("Failed to get featured images", error);
                setError(error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []); 

    if (loading) return <LoadingSpinner />;
    if (error) return <div style={{ color: 'red', padding: '20px' }}>Error loading featured designs: {error}</div>;

    return (
        <div>
            <h1>Choose a Pattern to color!</h1>
            {featuredImages.length === 0 ? (
                <p>No featured collections found.</p>
            ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {featuredImages.map(image => {
                        // CRITICAL PROTECTION: Skip rendering individual cards if they don't have basic tracking data
                        if (!image || !image.id) return null;
                        return <ImageCategoryCard image={image} key={image.id} />;
                    })}
                </div>
            )}
        </div>
    )
}